import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'

declare module '@tanstack/history' {
  interface HistoryState {
    /** Present when SPA navigates from `/games` catalog `Play` (or deep-link autostart); stripped after consumption. */
    boggleAutoStartStandardRun?: boolean
  }
}

export function getRouter() {
  return createRouter({
    routeTree,
    scrollRestoration: true,
  })
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}
